var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/currency', 'app-common/util/cache-manager'], function($, core, CurrencyCollection, cacheManager) {
  var CachedCurrencyCollection;
  CachedCurrencyCollection = (function(_super) {

    __extends(CachedCurrencyCollection, _super);

    function CachedCurrencyCollection() {
      CachedCurrencyCollection.__super__.constructor.apply(this, arguments);
    }

    CachedCurrencyCollection.prototype.initialize = function(models, options) {
      CachedCurrencyCollection.__super__.initialize.call(this, models, options);
      return cacheManager.wrapFetch(this, 'currency');
    };

    return CachedCurrencyCollection;

  })(CurrencyCollection);
  return CachedCurrencyCollection;
});
